// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"884":"19479924","897":"0febd026"}[chunkId] + ".js";
};